import { Component, OnInit, Input } from '@angular/core';
import { OhnLanguageService } from '../../services/ohn-language.service';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.scss'],
})
export class LoadingAnimationComponent implements OnInit {

	@Input() aniType: string; // "skeleton", "ring"
  @Input() aniText: string;

  constructor(
    private lS: OhnLanguageService,
  ) { }

  ngOnInit() {}
 
}
